import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-552ef8a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "datastore-row-drawer",
  class: "card card-drawer background-fb datastore-drawer"
}
const _hoisted_2 = { class: "card-header header-label d-flex flex-row justify-content-between align-items-center" }
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = { class: "card-body d-flex flex-column overflow-auto font-size-14" }
const _hoisted_5 = {
  key: 0,
  class: "color-red"
}
const _hoisted_6 = { class: "datastore-hint margin-left-3" }
const _hoisted_7 = {
  key: 0,
  class: "datastore-hint margin-top-10"
}
const _hoisted_8 = {
  key: 0,
  class: "footer card-footer d-flex justify-content-between align-items-center"
}
const _hoisted_9 = { class: "d-flex align-items-center" }

import { computed, reactive, watch } from "vue";
import {
  ElButton,
  ElDivider,
  ElInput,
  ElOption,
  ElSelect,
  ElSwitch,
} from "element-plus";
import { TYPE } from "vue-toastification";
import { showAlert, showConfirm } from "@/core/popup";
import i18n from "@/core/i18n/i18n";
import { DataStoreCell, DataStoreRow, DataStoreTable } from "@/datastore/types";
import {
  canDataStore,
  deleteRow,
  saveRow,
} from "@/datastore/services/datastore.service";


export default /*#__PURE__*/_defineComponent({
  __name: 'RowDetailDrawer',
  props: {
    table: {},
    row: {},
    readonly: { type: Boolean }
  },
  emits: ["close", "changed"],
  setup(__props: any, { emit: __emit }) {

const { t } = i18n.global;

const props = __props;
const emit = __emit;

const draft = reactive<Record<string, DataStoreCell>>({});
const editable = computed(() => canDataStore("DATA.EDIT") && !props.readonly);
const sortedFields = computed(() =>
  [...props.table.fields].sort((a, b) => a.ordinal - b.ordinal)
);

watch(
  () => props.row,
  () => {
    Object.keys(draft).forEach((key) => delete draft[key]);
    props.table.fields.forEach((field) => {
      const value = props.row?.cells[field.id];
      draft[field.id] = value ?? (field.type === "BOOLEAN" ? false : null);
    });
  },
  { immediate: true }
);

function setDraft(fieldId: string, value: DataStoreCell) {
  draft[fieldId] = value;
}

function stringDraft(fieldId: string): string {
  const value = draft[fieldId];
  return value == null ? "" : String(value);
}

async function onSave() {
  try {
    await saveRow(props.table.id, props.row?.id ?? null, { ...draft });
    showAlert(TYPE.SUCCESS, t("DataStore.RowSaved"));
    emit("changed");
    emit("close");
  } catch (e: any) {
    showAlert(TYPE.ERROR, e.message ?? t("Common.UnknownError"));
  }
}

async function onDelete() {
  if (!props.row) return;
  const confirmed = await showConfirm(
    "warning",
    t("DataStore.DeleteRow"),
    t("DataStore.DeleteRowWarning")
  );
  if (!confirmed) return;
  try {
    await deleteRow(props.table.id, props.row.id);
    showAlert(TYPE.WARNING, t("DataStore.RowDeleted"));
    emit("changed");
    emit("close");
  } catch (e: any) {
    showAlert(TYPE.ERROR, e.message ?? t("Common.UnknownError"));
  }
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, _toDisplayString(_ctx.row ? _unref(t)("DataStore.EditRow") : _unref(t)("DataStore.NewRow")), 1),
      _createElementVNode("button", {
        id: "datastore-row-drawer-close",
        type: "button",
        class: "btn btn-link",
        "aria-label": _unref(t)('Common.Close'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _createVNode(_component_font_awesome_icon, { icon: "times" })
      ], 8, _hoisted_3)
    ]),
    _createVNode(_unref(ElDivider), { style: {"margin":"0"} }),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedFields.value, (field) => {
        return (_openBlock(), _createElementBlock("div", {
          key: field.id,
          class: "margin-top-10 d-flex flex-column"
        }, [
          _createElementVNode("label", null, [
            _createElementVNode("strong", null, [
              _createTextVNode(_toDisplayString(field.name), 1),
              (field.required)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, "*"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("span", _hoisted_6, _toDisplayString(field.type), 1)
          ]),
          (field.type === 'BOOLEAN')
            ? (_openBlock(), _createBlock(_unref(ElSwitch), {
                key: 0,
                id: 'datastore-row-field-' + field.id,
                "active-color": "#5022a6",
                class: "element-switch-oneteg",
                width: 48,
                "model-value": draft[field.id] === true,
                disabled: !editable.value,
                "onUpdate:modelValue": (v) => setDraft(field.id, v)
              }, null, 8, ["id", "model-value", "disabled", "onUpdate:modelValue"]))
            : (field.type === 'SINGLE_SELECT')
              ? (_openBlock(), _createBlock(_unref(ElSelect), {
                  key: 1,
                  id: 'datastore-row-field-' + field.id,
                  "model-value": stringDraft(field.id),
                  size: "small",
                  class: "width-100",
                  clearable: "",
                  disabled: !editable.value,
                  "onUpdate:modelValue": (v) => setDraft(field.id, v)
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.settings?.options ?? [], (option) => {
                      return (_openBlock(), _createBlock(_unref(ElOption), {
                        key: option,
                        label: option,
                        value: option
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["id", "model-value", "disabled", "onUpdate:modelValue"]))
              : (_openBlock(), _createBlock(_unref(ElInput), {
                  key: 2,
                  id: 'datastore-row-field-' + field.id,
                  "model-value": stringDraft(field.id),
                  size: "small",
                  type: field.type === 'LONG_TEXT' ? 'textarea' : 'text',
                  disabled: !editable.value,
                  "onUpdate:modelValue": (v) => setDraft(field.id, v)
                }, null, 8, ["id", "model-value", "type", "disabled", "onUpdate:modelValue"]))
        ]))
      }), 128)),
      (!editable.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref(t)("DataStore.NeedDataEdit")), 1))
        : _createCommentVNode("", true)
    ]),
    (editable.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_ctx.row)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  id: "datastore-row-delete",
                  class: "btn btn-link datastore-danger-link p-0",
                  style: {"text-decoration":"none"},
                  type: "button",
                  onClick: onDelete
                }, _toDisplayString(_unref(t)("Common.Delete")), 1))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_unref(ElButton), {
            id: "datastore-row-save",
            class: "btn-oneTeg2",
            size: "small",
            onClick: onSave
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("DataStore.SaveRow")), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})